import client from './client';

export const smsSend = (body) =>
    client.post('/api/sche/smsSend', body);